/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCardThemeConfigs} from '../api'

 export const useQueryGetCardThemeConfigs = createReactQueryHook('getCardThemeConfigs', getCardThemeConfigs)
